import { render } from "./PointPage.vue?vue&type=template&id=72327287&scoped=true"
import script from "./PointPage.vue?vue&type=script&lang=js"
export * from "./PointPage.vue?vue&type=script&lang=js"

import "./PointPage.vue?vue&type=style&index=0&id=72327287&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72327287"]])

export default __exports__